import React, { useEffect } from "react";
import Banner from "../component/Home/Banner";
import SearchForm from "../component/Home/SearchForm";
import Discover from "../component/Home/Discover";
import TopDestinations from "../component/Home/TopDestinations";
import ExploreArea from "../component/Home/Explore";
import SpecialOffer from "../component/Home/SpecialOffers";
import PromotionalTours from "../component/Home/PromotionalTours";
import DestinationsArea from "../component/Home/Destinations";
import BlogMain from "../component/Home/LatestNews";

// import AboutArea
import AboutArea from "../component/About/AboutArea";
// import DiscountArea
// import AboutServices
import AboutServices from "../component/About/Services";
// import Consultation
import Consultation from "../component/About/Consultation";
// import Counter
import Counter from "../component/About/Counter";
// import CustomerReview
import CustomerReview from "../component/About/CustomerReview";
import TeamArea from "../component/TeamArea";
import VideoAreaTwo from "../component/BecomeExpert/VideoAreaTwo";
import VendorArea from "../component/BecomeExpert/Vendor";
//import { Helmet } from "react-helmet-async";
import SEOMetaTags from "../component/Seo/index";
//import { Helmet } from "react-helmet-async/lib";
import { Helmet } from "react-helmet-async";
import BookYourTravel from "../component/BookYourTravel";
const Home = () => {
  return (
    <>
      <Helmet>
        <title>Polani Travels | Home</title>
        <meta name="description" content="Your page specific description" />
        <meta name="keywords" content="travel packages, tours, polani" />
        <meta property="og:title" content="Polani Travels | Home" />
        <meta
          property="og:description"
          content="Your page specific description"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Your existing home content */}

      <Banner />
      {/* <SearchForm/> */}
      <Discover />
      <TopDestinations />
      <SpecialOffer />
      <VideoAreaTwo />
      {/* <AboutArea /> */}
      <Consultation />
      <Counter />
      <BookYourTravel />
      <ExploreArea />
      {/* <PromotionalTours /> */}
      <TeamArea />
      <CustomerReview />
      {/* <!-- Video Area --> */}

      {/* <!-- Vendor Form Area --> */}
      {/* <DestinationsArea /> */}
      {/* <BlogMain /> */}
    </>
  );
};

export default Home;
